
export function validatenull(val) {
    if (val instanceof Array) {
        if (val.length == 0) return true;
    } else if (val instanceof Object) {
        if (JSON.stringify(val) === '{}') return true;
    } else {
        if (val == 'null' || val == null || val == 'undefined' || val == undefined || val == '') return true;
        return false;
    }
    return false;

};
// 验证输入浮点数
export function IsDecimal(rule, value, callback) {
    ///为空不进行判断
    if (!value)
        return callback();
    else {
        var reg = /^(\-|\+)?\d+(\.\d+)?$/;
        if (reg.test(value))
            callback();
        else
            callback(new Error('输入格式不正确,请输入数字'));
    }
}
// 验证输入正数
export function IsInt(rule, value, callback) {
    ///为空不进行判断
    if (!value)
        return callback();
    else {
        var reg = /^-?[0-9]\d*$/;
        if (reg.test(value))
            callback();
        else
            callback(new Error('输入格式不正确,请输入整数'));
    }
}
//  手机号验证
export function IsPhoneNumber(value) {
    if (!value) {
        return false;
    } else {
        var reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (reg.test(value)) {
            return true;
        } else {
            return false;
        }
    }
}